(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-link-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const collectionLinkList = document.querySelector('.collection-link-list');
    const collectionLinkListContainer = document.querySelector('.collection-link-list__container');
    const collectionLinkListItems = collectionLinkListContainer.querySelectorAll('.collection-link-list__item');
    
    const collectionHandle = window.location.pathname.split('/').pop();

    collectionLinkListItems.forEach(item => {
      if (item.dataset.collectionhandle === collectionHandle) {
        item.classList.add('list__item--active');
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
